import React from 'react';
import { Typography } from '@mui/material';

const Title = ({ children, variant = 'h5', ...props }) => {
  return (
    <Typography variant={variant} component="h1" gutterBottom {...props}>
      {children}
    </Typography>
  );
};

export default Title;